// LoadingSpinner.tsx
import { BeatLoader } from 'react-spinners';
import './LoadingSpinner.css';

interface LoadingSpinnerProps {
  message?: string;
}

const LoadingSpinner = ({ message = 'Loading...' }: LoadingSpinnerProps) => {
  return (
    <div className="loading-spinner-container">
      <div className="loading-spinner-content">
        <BeatLoader color="#3498db" size={15} margin={5} />
        <div className="loading-spinner-text">{message}</div>
      </div>
    </div>
  );
};

export default LoadingSpinner;
